import { render, staticRenderFns } from "./date-panel.vue?vue&type=template&id=813d4cf2"
import script from "./date-panel.vue?vue&type=script&lang=js"
export * from "./date-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('813d4cf2')) {
      api.createRecord('813d4cf2', component.options)
    } else {
      api.reload('813d4cf2', component.options)
    }
    module.hot.accept("./date-panel.vue?vue&type=template&id=813d4cf2", function () {
      api.rerender('813d4cf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/datepicker/date-panel.vue"
export default component.exports